export default __webpack_public_path__ + "assets/models/187a7ca62738f5ad0e6aa93f7fdaa206.glb";